import type { BrandSpecial } from '@iheartjane/data-access';
import { useMemo } from 'react';

import { useGoldConfig } from '@jane/shared/data-access';
import { useSafeEcommApp } from '@jane/shared/providers';
import type { ProductWithBrandSpecialSegments } from '@jane/shared/util';

import { checkLocationAndStoreId } from './utils';

export interface ShouldShowGoldProps {
  brandSpecial?: Pick<BrandSpecial, 'rules'>;
  brandSpecials?: Pick<BrandSpecial, 'rules'>[];
  product?: ProductWithBrandSpecialSegments;
  store?: {
    id?: string | number;
    state?: string | null;
  };
}

export const useShouldShowGold = (props?: ShouldShowGoldProps): boolean => {
  const { appMode } = useSafeEcommApp();

  const { data: goldConfig, isLoading: isLoadingGoldConfig } = useGoldConfig();

  return useMemo(() => {
    if (isLoadingGoldConfig) return false;

    // check location and store ID and ignore the original janeGold flag
    if (goldConfig) {
      const validState = checkLocationAndStoreId(
        goldConfig,
        appMode,
        props?.store
      );

      return validState;
    }

    return true;
  }, [appMode, goldConfig, isLoadingGoldConfig, props]);
};
